import angular from 'angular';

'use strict';

const appUsersServices = angular.module('applicationModule.appUsersServices', []);


appUsersServices.factory('AppUsers', ['$state', 'Upload', 'AppUsersAPI', function ($state, Upload, AppUsersAPI) {
    'use strict';
    return {
        getList: function (appId, params) {
            return AppUsersAPI.getAppUsers(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        getDetail: function (appId, userId, type) {
            return AppUsersAPI.getUserDetail(appId, userId, type)
                .then(function (response) {
                    return response.data.detail[0];
                });
        },
        getDevice: function (userId) {
            return AppUsersAPI.getUserDevice(userId)
                .then(function (response) {
                    return response.data.device;
                });
        },
        getSchema: function (appId) {
            return AppUsersAPI.getSchema(appId)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (userId, appId) {
            return AppUsersAPI.getUserInfo(userId, appId);
        },
        save: function (data, images, editMode) {
            if (editMode) {
                return AppUsersAPI.saveUserInfo(data, images);
            }

            return AppUsersAPI.insertUserInfo(data, images);
        },
        dishOrders: function (appId, userId, date, params) {
            return AppUsersAPI.dishOrders(appId, userId, date, params)
                .then(function (response) {
                    return response.data;
                });
        },
        badges: function (appId, userId) {
            return AppUsersAPI.badges(appId, userId)
                .then(function (response) {
                    return response.data;
                });
        },
        search: function (appId, text, users) {
            return AppUsersAPI.search(appId, text, users);
        },
        searchGroups: function (appId, text) {
            return AppUsersAPI.searchGroups(appId, text);
        },
        searchPayers: function (appId, text) {
            return AppUsersAPI.searchPayers(appId, text);
        },
        remove: function (userId, appId) {
            return AppUsersAPI.removeUser(userId, appId);
        },
        getUsersActivities: function (appId, params) {
            return AppUsersAPI.getUsersActivities(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        saveGroups: function (usersData) {
            return AppUsersAPI.saveGroups(usersData);
        },
        import: function (appId, pageId, moduleId, data, files, incrementally) {
            return AppUsersAPI.importActionsData(appId, pageId, moduleId, data, files, incrementally);
        },
        deleteActionsData: function (appId, pageId, moduleId, file) {
            return AppUsersAPI.deleteActionsData(appId, pageId, moduleId, file);
        },
        importData: function (appId, file) {
            return AppUsersAPI.importData(appId, file);
        }
    };
}]);

appUsersServices.service('AppUsersAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    var API_URL = AppsoupAPI.API_URL + '/app/users/';

    var checkFiles = function (images) {
        var files = [];
        files = [];
        var names = [];
        names.files = [];

        angular.forEach(images, function (val, key) {
            if (angular.isDefined(val)) {
                files.push(val);
                names.push(key);
            }
        });

        return {files: files, names: names};
    };

    this.getAppUsers = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };
    this.getUserDetail = function (appId, userId, type) {
        return $http.get(API_URL + appId + '/' + userId + '/' + type);
    };
    this.getUserDevice = function (userId) {
        return $http.get(API_URL + 'device/' + userId);
    };
    this.getSchema = function (appId) {
        return $http.get(API_URL + 'schema/' + appId);
    };
    this.getUserInfo = function (userId, appId) {
        return $http.get(API_URL + userId, {params: {application_id: appId}});
    };
    this.saveUserInfo = function (data, images) {
        if (angular.isDefined(images) && Object.keys(images).length > 0) {
            var files = checkFiles(images);
            var newfields = angular.extend(data, {_method: 'PUT'});

            return Upload.upload({
                url: API_URL + data.id,
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: newfields,
                file: files.files,
                fileFormDataName: files.names
            });
        } else {
            return $http.put(API_URL + data.id, data);
        }
    };
    this.importActionsData = function (appId, pageId, moduleId, data, files, incrementally) {
        if (angular.isDefined(files) && Object.keys(files).length > 0) {
            files = checkFiles(files);
            data = angular.copy(data);
            data.application_id = appId;
            data.page_id = pageId;
            data.module_id = moduleId;
            data.incrementally = incrementally;

            return Upload.upload({
                url: API_URL + 'import',
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: data,
                file: files.files,
                fileFormDataName: files.names
            });
        }
    };
    this.deleteActionsData = function (appId, pageId, moduleId, file) {
        if (angular.isDefined(file)) {
            var data = {};
            data.application_id = appId;
            data.page_id = pageId;
            data.module_id = moduleId;

            return Upload.upload({
                url: API_URL + 'delete',
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: data,
                file: file,
                fileFormDataName: file.names
            });
        }
    };
    this.insertUserInfo = function (data, images) {
        if (angular.isDefined(images) && Object.keys(images).length > 0) {
            var files = checkFiles(images);

            return Upload.upload({
                url: API_URL,
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: data,
                file: files.files,
                fileFormDataName: files.names
            });
        } else {
            return $http.post(API_URL, data);
        }
    };

    this.dishOrders = function (appId, userId, date, params) {
        if (params) {
            return $http.get(API_URL + 'dish/orders', {
                params: angular.extend(AppsoupAPI.getTableParams(params), {
                    application_id: appId,
                    mobile_user_id: userId,
                    date: date
                })
            });
        }

        return $http.get(API_URL + 'dish/orders', {
            params: {
                application_id: appId,
                mobile_user_id: userId,
                date: date
            }
        });
    };

    this.badges = function (appId, userId) {
        return $http.get(API_URL + 'gamification/badges', {params: {application_id: appId, user_id: userId}});
    };

    this.search = function (appId, text) {
        return $http.get(API_URL + 'search/' + appId + '/' + text);
    };

    this.searchGroups = function (appId, text) {
        return $http.get(API_URL + 'groups/search/' + appId + '/' + text);
    };

    this.searchPayers = function (appId, text) {
        return $http.get(API_URL + 'payers/search/' + appId + '/' + text);
    };

    this.removeUser = function (userId, appId) {
        return $http.delete(API_URL + 'delete/' + userId + '/' + appId);
    };

    this.getUsersActivities = function (appId, params) {
        return $http.get(API_URL + 'activities/users', {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };
    this.saveGroups = function (usersData) {
        return $http.post(API_URL + 'add/groups', usersData);
    };
    this.importData = function (appId, file) {
        var data = {
            application_id: appId
        };

        return Upload.upload({
            url: API_URL + 'import/data/' + appId,
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: data,
            file: file
        });
    };
}]);

export default appUsersServices;
